export const FETCH_BOOKINGS = "FETCH_BOOKINGS";
export const UPDATE_BOOKING_CANCELED = "UPDATE_BOOKING_CANCELED";
export const UPDATE_BOOKING_CHECKED = "UPDATE_BOOKING_CHECKED";
export const UPDATE_BOOKING_VISITED = "UPDATE_BOOKING_VISITED";

export const pending = "pending";
export const accepted = "accepted";
export const visited = "visited";
export const unvisited = "unvisited";
export const unknown = "unknown";
export const cancled = "cancled";

// export const NEW_ENG = 'new';
// export const CHECKED_ENG = 'checked';
// export const VISITED_ENG = 'visited';
// export const NOT_VISITED_ENG = 'notVisited';
// export const NULL_VISITED_ENG = 'nullVisited';
// export const CANCELED_ENG = 'canceled';
